import loadMapsAPI from './loadMapsAPI';
const initializeMapsAPI = () => {
    return new Promise((resolve, reject) => {
        try {
            const handleLoadedAPI = resolve;
            if (!window.onGoogleAPILoaded) {
                window.onGoogleAPILoaded = handleLoadedAPI;
            }
            loadMapsAPI({
                URLOptions: { callback: 'onGoogleAPILoaded' },
                handleLoadedAPI,
            });
        }
        catch (error) {
            reject(error);
        }
    }).then(() => window.google.maps);
};
export default initializeMapsAPI;
//# sourceMappingURL=initializeMapsAPI.js.map